import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/TwitterVerificationNotice.css';

const TwitterVerificationNotice = () => {
  const { user, isAuthenticated } = useContext(AuthContext);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  // Don't show if user is not authenticated
  if (!isAuthenticated || !user) {
    return null;
  }

  // Don't show if user is admin (exempt from Twitter requirement)
  if (user.accountType === 'admin') {
    return null;
  }

  // Don't show if user has already verified Twitter
  const hasVerifiedTwitter = user.socialAccounts?.twitter?.verified;
  if (hasVerifiedTwitter) {
    return null;
  }

  // Don't show if user dismissed the notice (stored in localStorage)
  const dismissedKey = `twitter-notice-dismissed-${user._id}`;
  const isDismissedInStorage = localStorage.getItem(dismissedKey);
  if (dismissed || isDismissedInStorage) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    // Remember dismissal for 24 hours
    const expiryTime = new Date().getTime() + (24 * 60 * 60 * 1000);
    localStorage.setItem(dismissedKey, expiryTime.toString());
  };

  const handleVerify = () => {
    navigate('/settings', { state: { scrollToTwitter: true } });
  };

  return (
    <div className="twitter-verification-notice">
      <div className="notice-container">
        <div className="notice-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <div className="notice-content">
          <h3 className="notice-title">🔔 Action Required: Link Your Twitter Account</h3>
          <p className="notice-message">
            To continue using key features like entering giveaways, writing reviews, and posting content, 
            you must verify your Twitter account. This helps us maintain a trusted community and prevent spam.
          </p>
          <div className="notice-actions">
            <button className="btn-verify" onClick={handleVerify}>
              Verify Twitter Account
            </button>
            <button className="btn-dismiss" onClick={handleDismiss}>
              Remind Me Later
            </button>
          </div>
        </div>
        <button className="notice-close" onClick={handleDismiss} aria-label="Close notice">
          ×
        </button>
      </div>
    </div>
  );
};

export default TwitterVerificationNotice;
